// extracted by mini-css-extract-plugin
export var content = "_4-3";
export var footer = "_4-4";
export var header = "_4-1";
export var panel = "_4-0";
export var tabsWrapper = "_4-2";